// Prefetch route chunks on hover/focus to avoid blank Suspense fallback on click.
// Vite dedupes the dynamic import promise, so calling these multiple times is safe.

export const prefetchCalculator = () => import('@/pages/Calculator');
export const prefetchContact = () => import('@/pages/Contact');
export const prefetchServicii = () => import('@/pages/Servicii');
export const prefetchDespre = () => import('@/pages/DespreNoiSolyra');
